exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-header[data-v-5a4b4bbd]{background-color:#fbfbfb}.setting-body[data-v-5a4b4bbd]{background-color:#fdfdfd}input[data-v-5a4b4bbd],textarea[data-v-5a4b4bbd]{border-style:solid}.token_password_toggle[data-v-5a4b4bbd]{position:absolute;margin-top:-30px;right:20px}", ""]);

// exports
